import { BIOME, BLOCK, type Biome } from "../../types";
import { buildCabin } from "./builders/cabin";
import { buildDeadTree } from "./builders/deadTree";
import { buildIgloo } from "./builders/igloo";
import { buildLogPile } from "./builders/logPile";
import { buildMesaMine } from "./builders/mesaMine";
import { buildMushroomCircle } from "./builders/mushroomCircle";
import { buildNetherShrine } from "./builders/netherShrine";
import { buildPyramid } from "./builders/pyramid";
import { buildRuin } from "./builders/ruin";
import { buildStoneArch } from "./builders/stoneArch";
import { buildSwampHut } from "./builders/swampHut";
import { buildWatchtower } from "./builders/watchtower";
import { buildWell } from "./builders/well";
import { StructureId, type StructureDefinition } from "./types";

export const OVERWORLD_STRUCTURES = {
    [BIOME.Icy]: [
        { id: StructureId.Igloo, surfaces: [BLOCK.SnowBlock, BLOCK.Grass], footprint: 7, build: buildIgloo },
    ],
    [BIOME.ColdForest]: [
        { id: StructureId.Cabin, surfaces: [BLOCK.Grass], footprint: { width: 7, depth: 5 }, build: buildCabin },
        { id: StructureId.Watchtower, surfaces: [BLOCK.Grass], footprint: 5, build: buildWatchtower },
    ],
    [BIOME.Taiga]: [
        { id: StructureId.LogPile, surfaces: [BLOCK.Grass], footprint: 5, build: buildLogPile },
        { id: StructureId.Watchtower, surfaces: [BLOCK.Grass], footprint: 5, build: buildWatchtower },
    ],
    [BIOME.Temperate]: [
        { id: StructureId.StoneArch, surfaces: [BLOCK.Grass], footprint: 7, build: buildStoneArch },
        { id: StructureId.Well, surfaces: [BLOCK.Grass], footprint: 5, build: buildWell },
    ],
    [BIOME.Humid]: [
        { id: StructureId.Ruin, surfaces: [BLOCK.Grass], footprint: 7, build: buildRuin },
        { id: StructureId.Well, surfaces: [BLOCK.Grass], footprint: 5, build: buildWell },
    ],
    [BIOME.Swamp]: [
        { id: StructureId.SwampHut, surfaces: [BLOCK.CoarseDirt, BLOCK.Grass], footprint: 5, build: buildSwampHut },
    ],
    [BIOME.Savanna]: [
        { id: StructureId.DeadTree, surfaces: [BLOCK.Grass], footprint: 5, build: buildDeadTree },
    ],
    [BIOME.Desert]: [
        { id: StructureId.Pyramid, surfaces: [BLOCK.Sand], footprint: 9, build: buildPyramid },
    ],
    [BIOME.Mesa]: [
        {
            id: StructureId.MesaMine,
            surfaces: [BLOCK.Terracotta, BLOCK.RedTerracotta, BLOCK.WhiteTerracotta],
            footprint: 7,
            build: buildMesaMine,
        },
    ],
    [BIOME.Mushroom]: [
        { id: StructureId.MushroomCircle, surfaces: [BLOCK.Mycelium], footprint: 7, build: buildMushroomCircle },
    ],
} satisfies Record<Biome, readonly StructureDefinition[]>;

export const NETHER_STRUCTURES = [
    {
        id: StructureId.NetherShrine,
        surfaces: [BLOCK.Netherrack],
        footprint: 5,
        build: buildNetherShrine,
    },
] satisfies readonly StructureDefinition[];
